import React from "react";

export default function Input({ data, grayed = false }) {
    const rows = data ?? [];

    // Convert "company_name" → "Company Name"
    const toTitleCase = (value) =>
        (value ?? "")
            .toString()
            .replace(/[_\-]+/g, " ")
            .trim()
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(" ");

    const cellStyle = {
        padding: "4px 6px",
        ...(grayed && { position: "relative" })
    };

    return (
        <table className="hc-table" style={{ width: "100%", fontSize: "12px" }}>
            <tbody>
            {rows.map((r, i) => (
                <tr className="hc-row" key={i}>
                    <td className="hc-desc" title={r.state} style={cellStyle}>
                        {r.type}
                        {grayed && (
                            <div style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(128, 128, 128, 0.15)",
                                pointerEvents: "none"
                            }}></div>
                        )}
                    </td>
                    <td style={cellStyle}>
                        {r.value}
                        {grayed && (
                            <div style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(128, 128, 128, 0.15)",
                                pointerEvents: "none"
                            }}></div>
                        )}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}
